// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.6.8_@swc+helpers@0.5.23__webpack@5.108.4_@swc+core@1.15_b0345aabf8a2fe8f5423f3b3e9febcd5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.6.8_@swc+helpers@0.5.23__webpack@5.108.4_@swc+core@1.15_b0345aabf8a2fe8f5423f3b3e9febcd5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    font-size: 16px !important;
}

body {
    margin: 0;
    padding: 0;
    width: 100vw;
    height: 100dvh;
}

#mainClientLayout, .pg7yhRjb__app__styles-module__wrapper___qhJphOy044cPbnTB {
    width: 100%;
    height: 100%;
}

.pg7yhRjb__app__styles-module__wrapper___qhJphOy044cPbnTB {
    display: flex;
    justify-content: center;
    background-color: var(--ds-color-surface-soft);
    padding: 1rem 2.5rem;
}

.pg7yhRjb__app__styles-module__centeredLayout___E4pwEwCS1GMcGB1V {
    display: flex;
    flex-direction: column;
    max-width: 82rem;
    width: 100%;
    min-height: 0;
    flex: 1 1;
}

.pg7yhRjb__app__styles-module__content___YCLoe4oJiOMVWIvH {
    display: flex;
    flex: 1 1;
    min-height: 0;
    overflow: hidden;
    background-color: var(--ds-color-surface-main);
    border-radius: var(--ds-radius-xl);
    box-shadow: var(--ds-shadow-standard-m);
}

.pg7yhRjb__app__styles-module__marketingBlock___rV9hWZoqN7sri3tq {
    position: relative;
    flex-basis: 40%;
    padding: 2.5rem 2.25rem;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    color: var(--ds-color-text-main-onbrand);
    background: radial-gradient(120% 90% at 85% 0%, rgba(124,58,237,0.55) 0%, rgba(124,58,237,0) 55%), linear-gradient(158deg, #1c0f3a 0%, #3b1a82 45%, #5b21b6 100%);
}

.pg7yhRjb__app__styles-module__formWrapper___P720oRYTce03kH6s {
    flex-basis: 60%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow-y: auto;
    min-height: 0;
    overscroll-behavior: contain;
    scroll-padding-block: 2rem;
}

.pg7yhRjb__app__styles-module__form___etvKIcJKa_gMkvqy {
    width: 100%;
    max-width: 36rem;
    padding: 2rem 2.5rem;
}

.pg7yhRjb__app__styles-module__rings___sUJRURoUycS73eCh {
    position: absolute;
    top: -90px;
    right: -120px;
    width: 420px;
    height: 420px;
    border-radius: 50%;
    border: 1.5px solid rgba(255, 255, 255, 0.07);
    box-shadow: inset 0 0 0 60px rgba(255, 255, 255, 0.04), 0 0 0 70px rgba(255, 255, 255, 0.05);
    pointer-events: none;
}

/* --- Responsive breakpoints --- */

@media (max-width: 1280px) {
    .pg7yhRjb__app__styles-module__productDescription___OZrTzHbl2ZcfkC1M {
        width: 100%;
        display: flex;
    }
}

@media (max-width: 860px) {
    .pg7yhRjb__app__styles-module__wrapper___qhJphOy044cPbnTB {
        height: auto;
        min-height: 100%;
        overflow-y: auto;
    }

    .pg7yhRjb__app__styles-module__centeredLayout___E4pwEwCS1GMcGB1V {
        flex: initial;
    }

    .pg7yhRjb__app__styles-module__content___YCLoe4oJiOMVWIvH {
        flex-direction: column;
        flex: initial;
        overflow: visible;
    }

    .pg7yhRjb__app__styles-module__formWrapper___P720oRYTce03kH6s {
        flex-basis: auto;
        order: -1;
        overflow-y: visible;
    }

    .pg7yhRjb__app__styles-module__marketingBlock___rV9hWZoqN7sri3tq {
        flex-basis: auto;
        padding: 1.5rem;
        border-radius: 0 0 var(--ds-radius-xl) var(--ds-radius-xl);
    }

    .pg7yhRjb__app__styles-module__rings___sUJRURoUycS73eCh {
        width: 300px;
        height: 300px;
        top: -70px;
        right: -90px;
    }
}

@media (max-width: 640px) {
    .pg7yhRjb__app__styles-module__wrapper___qhJphOy044cPbnTB {
        padding: 0;
        background-color: var(--ds-color-surface-main);
    }

    .pg7yhRjb__app__styles-module__content___YCLoe4oJiOMVWIvH {
        border-radius: 0;
        box-shadow: none;
    }

    .pg7yhRjb__app__styles-module__marketingBlock___rV9hWZoqN7sri3tq {
        padding: 1rem;
    }

    .pg7yhRjb__app__styles-module__form___etvKIcJKa_gMkvqy {
        padding: 1.5rem 1rem;
    }

    .pg7yhRjb__app__styles-module__rings___sUJRURoUycS73eCh {
        display: none;
    }
}

@media (max-height: 700px) {
    .pg7yhRjb__app__styles-module__wrapper___qhJphOy044cPbnTB {
        padding: 1rem;
    }

    .pg7yhRjb__app__styles-module__form___etvKIcJKa_gMkvqy {
        padding: 1.5rem;
    }
}

/* View Transition accessibility */
@media (prefers-reduced-motion: reduce) {
    ::view-transition-group(*), ::view-transition-old(*), ::view-transition-new(*) {
        animation: none !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/modules/app/styles.module.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,cAAc;AAClB;;AAEA;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8CAA8C;IAC9C,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,SAAO;AACX;;AAEA;IACI,aAAa;IACb,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,8CAA8C;IAC9C,kCAAkC;IAClC,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,wCAAwC;IACxC,iKAAiK;AACrK;;AAEA;IACI,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,6CAA6C;IAC7C,4FAA4F;IAC5F,oBAAoB;AACxB;;AAEA,mCAAmC;;AAEnC;IACI;QACI,WAAW;QACX,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,0DAA0D;IAC9D;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,UAAU;QACV,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,8CAA8C;IAClD;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,kCAAkC;AAClC;IACI;QAGI,0BAA0B;IAC9B;AACJ","sourcesContent":[":global html {\n    font-size: 16px !important;\n}\n\n:global body {\n    margin: 0;\n    padding: 0;\n    width: 100vw;\n    height: 100dvh;\n}\n\n:global(#mainClientLayout),\n.wrapper {\n    width: 100%;\n    height: 100%;\n}\n\n.wrapper {\n    display: flex;\n    justify-content: center;\n    background-color: var(--ds-color-surface-soft);\n    padding: 1rem 2.5rem;\n}\n\n.centeredLayout {\n    display: flex;\n    flex-direction: column;\n    max-width: 82rem;\n    width: 100%;\n    min-height: 0;\n    flex: 1;\n}\n\n.content {\n    display: flex;\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n    background-color: var(--ds-color-surface-main);\n    border-radius: var(--ds-radius-xl);\n    box-shadow: var(--ds-shadow-standard-m);\n}\n\n.marketingBlock {\n    position: relative;\n    flex-basis: 40%;\n    padding: 2.5rem 2.25rem;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    color: var(--ds-color-text-main-onbrand);\n    background: radial-gradient(120% 90% at 85% 0%, rgba(124,58,237,0.55) 0%, rgba(124,58,237,0) 55%), linear-gradient(158deg, #1c0f3a 0%, #3b1a82 45%, #5b21b6 100%);\n}\n\n.formWrapper {\n    flex-basis: 60%;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    overflow-y: auto;\n    min-height: 0;\n    overscroll-behavior: contain;\n    scroll-padding-block: 2rem;\n}\n\n.form {\n    width: 100%;\n    max-width: 36rem;\n    padding: 2rem 2.5rem;\n}\n\n.rings {\n    position: absolute;\n    top: -90px;\n    right: -120px;\n    width: 420px;\n    height: 420px;\n    border-radius: 50%;\n    border: 1.5px solid rgba(255, 255, 255, 0.07);\n    box-shadow: inset 0 0 0 60px rgba(255, 255, 255, 0.04), 0 0 0 70px rgba(255, 255, 255, 0.05);\n    pointer-events: none;\n}\n\n/* --- Responsive breakpoints --- */\n\n@media (max-width: 1280px) {\n    .productDescription {\n        width: 100%;\n        display: flex;\n    }\n}\n\n@media (max-width: 860px) {\n    .wrapper {\n        height: auto;\n        min-height: 100%;\n        overflow-y: auto;\n    }\n\n    .centeredLayout {\n        flex: initial;\n    }\n\n    .content {\n        flex-direction: column;\n        flex: initial;\n        overflow: visible;\n    }\n\n    .formWrapper {\n        flex-basis: auto;\n        order: -1;\n        overflow-y: visible;\n    }\n\n    .marketingBlock {\n        flex-basis: auto;\n        padding: 1.5rem;\n        border-radius: 0 0 var(--ds-radius-xl) var(--ds-radius-xl);\n    }\n\n    .rings {\n        width: 300px;\n        height: 300px;\n        top: -70px;\n        right: -90px;\n    }\n}\n\n@media (max-width: 640px) {\n    .wrapper {\n        padding: 0;\n        background-color: var(--ds-color-surface-main);\n    }\n\n    .content {\n        border-radius: 0;\n        box-shadow: none;\n    }\n\n    .marketingBlock {\n        padding: 1rem;\n    }\n\n    .form {\n        padding: 1.5rem 1rem;\n    }\n\n    .rings {\n        display: none;\n    }\n}\n\n@media (max-height: 700px) {\n    .wrapper {\n        padding: 1rem;\n    }\n\n    .form {\n        padding: 1.5rem;\n    }\n}\n\n/* View Transition accessibility */\n@media (prefers-reduced-motion: reduce) {\n    :global(::view-transition-group(*)),\n    :global(::view-transition-old(*)),\n    :global(::view-transition-new(*)) {\n        animation: none !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export var wrapper = `pg7yhRjb__app__styles-module__wrapper___qhJphOy044cPbnTB`;
export var centeredLayout = `pg7yhRjb__app__styles-module__centeredLayout___E4pwEwCS1GMcGB1V`;
export var content = `pg7yhRjb__app__styles-module__content___YCLoe4oJiOMVWIvH`;
export var marketingBlock = `pg7yhRjb__app__styles-module__marketingBlock___rV9hWZoqN7sri3tq`;
export var formWrapper = `pg7yhRjb__app__styles-module__formWrapper___P720oRYTce03kH6s`;
export var form = `pg7yhRjb__app__styles-module__form___etvKIcJKa_gMkvqy`;
export var rings = `pg7yhRjb__app__styles-module__rings___sUJRURoUycS73eCh`;
export var productDescription = `pg7yhRjb__app__styles-module__productDescription___OZrTzHbl2ZcfkC1M`;
export default ___CSS_LOADER_EXPORT___;
